import React, { useState } from 'react'
import useSingleStation from '../../../hooks/useSingleStation';
import useChargingSessionAdmin, { useChargingSessionSumAnalysis } from '../../../../chargingSession/hooks/useChargingSession';
import { Filter } from '../../../../../utils/genericAPI/useGenericAPI';
import { ChargingSessionPatch } from '../../../../chargingSession/types/chargingSession.types';
import { numberFormaterString } from '../../../../../utils/numberFormater';
import { useFilterAnalysis } from '../../../../../common/analysis/filter/hook';
import FilterPresenter from '../../../../../common/analysis/filter/components/Filter/FilterPresenter';

import { converteTitle, createList } from '../../../../../common/analysis/utils/graph.utils';
import ButtonPlus from '../../../../../common/components/atom/ButtonPlus/ButtonPlus';
import { MeasurandData } from '../../../types/stations.types';
import { useStationData } from '../../../hooks/StationAnalysis/useStationDataEnergyActiveImport';
import ChartLoaderView from '../../../../../common/components/molecule/Chart/ChartLoaderView/ChartLoaderView';
import { AxiosError } from 'axios';
import { extractAxoisErrorsMessage } from '../../../../errorHandler/utils/errors.utils';
import BarCharView from '../../../../../common/components/molecule/Chart/BarCharView/BarCharView';
import ChartLineView from '../../../../../common/components/molecule/Chart/ChartLineView/ChartLineView';
import Modal from '../../../../../common/components/molecule/Modal/Modal';

export const NbChargingSessionsProvided = ({ stationId }: { stationId?: string, preFilter?: Filter<ChargingSessionPatch> }) => {

        const { stationId: paramId } = useSingleStation()
    
        const stationIdFound = stationId || paramId;
        const {filter} = useFilterAnalysis()

        const {getAllChargingSession} = useChargingSessionAdmin({
            filter: {
                cs_station: `=${stationIdFound}`,
                cs_create_at: filter.startDate && filter.startDate ? `<btw>[${filter.startDate},${filter.stopDate}]` : undefined,
            },
            pageSize: 1,
            hookId: "nbcsp",

        })

        if (getAllChargingSession.isLoading) {
            return (
                <>...</>
            )
        }
        if (getAllChargingSession.isError) {
            return <>-</>
        }

        return (
            <>{getAllChargingSession.data?.pagination.total_count}</>
        )


}


export const TotalMoney = ({ stationId }: { stationId?: string, preFilter?: Filter<ChargingSessionPatch> }) => {
    const {filter} = useFilterAnalysis()
    const { stationId: paramId } = useSingleStation()

    const stationIdFound = stationId || paramId;


    const { sumChargingSessionAnalysisQuery: getSumQuery} = useChargingSessionSumAnalysis("cs_price",{
        preFilter: {
            cs_station: `=${stationIdFound}`,
            cs_create_at: filter.startDate && filter.startDate ? `<btw>[${filter.startDate},${filter.stopDate}]` : undefined,
        },
    })

    if (getSumQuery.isLoading) {
        return (
            <>...</>
        )
    }
    if (getSumQuery.isError) {
        return <>-</>
    }

    if (!getSumQuery.data || !getSumQuery.data?.data || getSumQuery.data?.data.length === 0) {
        return <>0</>
    }

    return (
        <>{numberFormaterString(getSumQuery.data?.data[0].total)}</>
    )
}

export interface FilterTimeWindowBtnProps {
    openButtonRender?: (options?: {handleOpen: () => void, timeLabel?: string}) => React.JSX.Element;
}
export const FilterTimeWindowBtn = ({openButtonRender}: FilterTimeWindowBtnProps) => {

    const {filter} = useFilterAnalysis()
    const [isOpen, setIsOpen] = useState(false)
    const handleClose = () => {
        setIsOpen(false)
    }
    const labelTime = converteTitle(filter.startDate|| "", filter.stopDate|| "")

    return <>

            {
                openButtonRender ?
                openButtonRender({handleOpen: () => setIsOpen(true), timeLabel: labelTime}) :
            
            <ButtonPlus onClick={() => setIsOpen(true)} iconType="time" >
                {labelTime}
            </ButtonPlus>
        }     
            <Modal  isOpen={isOpen} handleClose={handleClose} >
                 <FilterPresenter handleClose={handleClose}/>
            </Modal>
            </>


}

export default function StationChart({measurand, stationId, 
    label, 
    unit, 
    convert, 
    chartType = "line"
}: { measurand: MeasurandData, stationId?: string, label?: string, unit?: string, convert?: (value: number) => number, chartType?: "line" | "bar" }) {
  const { dataQuery, filter } = useStationData(measurand, stationId);

  if (dataQuery.isLoading) {
    return <ChartLoaderView />;
  }
  if (dataQuery.isError && dataQuery.error) {
    const error = dataQuery.error as AxiosError;

    const message = extractAxoisErrorsMessage(error);

    if (message.includes("no data found")) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "gray",
          }}
        >
          <p>Aucune donnée trouvée</p>{" "}
        </div>
      );
    }

    return <div>Error occure {error.message}</div>;
  }

  const dataChart = createList(
    filter.aggregateWindow || "1d",
    filter,
    dataQuery.data || []
  );

  if (chartType === "line") {
    return (
      <ChartLineView
        xAxisData={dataChart.listx.map((item) => new Date(item))}
        data={dataChart.listValue.map((item) => convert ? convert(item) : item)}
        label={label}
        unit={unit}
      />
    );
  }

  if (chartType === "bar") {
       return (
      <BarCharView
        xAxisData={dataChart.listx.map((item) => new Date(item))}
        data={dataChart.listValue.map((item) => convert ? convert(item) : item)}
        label={label}
        unit={unit}
      />
    );
  }

  return (
    <BarCharView
      xAxisData={dataChart.listx.map((item) => new Date(item))}
      data={dataChart.listValue.map((item) => convert ? convert(item) : item)}
      label={label}
      unit= {unit}
    />
  );
}